import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "g_id_onload",
  "data-client_id": "214923478109-ot56okp0olmetmaih8va0eo5k4pk8m47.apps.googleusercontent.com",
  "data-context": "signin",
  "data-callback": "handleCredentialResponse"
}

import { computed, inject } from 'vue';
import {loginFn} from '@/hooks/index'
import { Toast } from "vant";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const $http: any = inject('$http')
const app_token = computed(() => {
  return common.getStorage('access_token')
})

/**
 * 登陆逻辑
 */
const login =  async  (para: any) => {          
    let ret = await $http.login(para)
    if (ret.code == 200) {                
      if(!ret.data.email && !ret.data.phone){
        loginFn(ret.data,$http, 'bind');
        
      }else{
        loginFn(ret.data,$http,'');
      } 
    } else{
        Toast(ret.message);
    }
    return ret
}
/**
 * 解析jwt获取数据
 */
const get_google_user_infu_fn = (token: string) => {
  let strings = token.split("."); //截取token，获取载体
  let userinfo = JSON.parse(decodeURIComponent(escape(window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/"))))); //解析，需要吧‘_’,'-'进行转换否则会无法解析
  return userinfo
}
/**
 * Google auto2.0
 */
const  googleLogin = async (id_token: string) => {
  let userinfo = get_google_user_infu_fn(id_token)
  try {
    let google_login_params = {
      googleIdToken: id_token,
      source: '3',
      sl_source: '',
      third_firstname: userinfo.given_name,
      third_lastname: userinfo.family_name,
      third_avatar: '',
      third_email: userinfo.email,
      google_quick: 1,
    }
    login(google_login_params)

  } catch (error) {
    console.log(error);
    return null;
  }
}
window.handleCredentialResponse =  (response: any) => {
  let jwt_str = response.credential
  if(!jwt_str) return null;
  googleLogin(jwt_str)

}

return (_ctx: any,_cache: any) => {
  return (!_unref(app_token))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : _createCommentVNode("", true)
}
}

})